import { initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';

// GA4 principal é carregado via gtag em index.html (G-K7SE125H5D).
// Só inclui measurementId se vier do env — um ID local desalinhado do
// console gera warning e beacons com id=undefined (CSP).
const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim();

/** Só em desenvolvimento local, com REACT_APP_USE_EMULATORS=true (nunca no build de produção). */
const USE_EMULATORS = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_EMULATORS === 'true';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBk7Xy_zfgUxSjpEfGPHFOrLTvoPfACktE",
  // IMPORTANTE: Usar web.app para manter consistência com o domínio do site
  // Se usar firebaseapp.com, o redirect perde o estado entre domínios diferentes
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "upclinic-aa025.web.app",
  // Simulação local (emuladores): projeto fictício — nada vai para a produção.
  projectId: USE_EMULATORS ? 'demo-upclinic' : process.env.REACT_APP_FIREBASE_PROJECT_ID || "upclinic-aa025",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "upclinic-aa025.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "821231945105",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:821231945105:web:697bda4eb3f34a2bd08630",
  ...(measurementId ? { measurementId } : {}),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Get Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1'); // Especificar região explicitamente
export const storage = getStorage(app);

if (USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  // eslint-disable-next-line no-console
  console.warn('[FIREBASE] Modo simulação: emuladores locais (projeto demo-upclinic).');
}
export let analytics: Analytics | null = null;
if (typeof window !== 'undefined' && measurementId) {
  void isSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app);
  });
}

// Exportar app explicitamente para uso em imports dinâmicos
export { app };

// Configurar idioma do Firebase Auth para português (Brasil)
// Isso afeta emails de recuperação de senha, verificação de email, etc.
// IMPORTANTE: Configurar ANTES de qualquer uso do auth
if (!auth.languageCode || auth.languageCode !== 'pt-BR') {
  auth.languageCode = 'pt-BR';
}


export default app;
